import { ApiGetRequest, ICounterParty } from 'types';

import { EWalletNetwork } from 'modules/wallet';

export enum ETransactionStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  NO_CONFIRMATION = 'no_confirmation',
  UNPAID = 'unpaid',
}

export enum EEecsTransactionType {
  BUY = 'buy',
  SELL = 'sell',
}

export enum EEecsTransactionModals {
  DETAILS = 'details',
}

export enum EPaymentMethod {
  SEPA = 'sepa_debit',
  CARD = 'card',
  WALLET = 'wallet',
  FREE = 'free',
  MANUAL = 'manual',
}

export const PaymentMethodMap: Record<EPaymentMethod, string> = {
  [EPaymentMethod.SEPA]: 'SEPA',
  [EPaymentMethod.CARD]: 'Card',
  [EPaymentMethod.WALLET]: 'Wallet',
  [EPaymentMethod.FREE]: 'FREE',
  [EPaymentMethod.MANUAL]: 'Manual',
};

export interface FetchEecsTransactionPayload extends ApiGetRequest {
  start_date?: string;
  end_date?: string;
  transaction_type: EEecsTransactionType;
  order_txn_id?: 'asc' | 'desc';
  order_transaction_type?: 'asc' | 'desc';
  order_transaction_date?: 'asc' | 'desc';
  order_buyer_necs_company_name?: 'asc' | 'desc';
  transaction_status?: string | null;
}

export interface ConfirmEecsTransactionPaymentPayload {
  id: string;
  type: 'fee' | 'order';
}

export interface IEecsTransactionBundle {
  seller_bundle_id: number | null;
  counter_party_bundle_id: number | null;
  production_device_name: string;
  production_device_id: string;
  type_of_installation_code: string;
  type_of_installation_path: string[];
  energy_source_code: string;
  energy_source_code_path: string[];
  production_period_start: string;
  production_period_end: string;
  issued_date: string;
  date_of_expiration: string;
  volume: number;
}
export interface IEecsTransaction {
  id: string;
  transaction_id: string | null;
  certificate_group_id: string | null;
  stripe_payment_id: string | null;
  wallet_txn_hash: string | null;
  wallet_fee_txn_hash: string | null;
  volume: number;
  price: number;
  seller_company_id: number;
  transaction_date: string;
  counter_party?: ICounterParty;
  transaction_type: EEecsTransactionType;
  transaction_status: ETransactionStatus;
  go_certificate_id: number;
  go_exchange_id: number;
  cancellation_reason: string[];
  production_period_start: string | null;
  production_period_end: string | null;
  seller_bundle_id: number | null;
  production_device_name: string | null;
  production_device_id: string | null;
  issued_date: string | null;
  date_of_expiration: string | null;
  type_of_installation_code: string;
  type_of_installation_path: string[];
  energy_source_code: string;
  energy_source_code_path: string[];
  production_year: string;
  type_of_support: string;
  aib_grid_connected: boolean;
  bundles_list: IEecsTransactionBundle[];
  order_list: {
    price: number;
    volume: number;
  }[];

  forward_did: string | null;
  payment_method: EPaymentMethod | null;
  wallet_blockchain: EWalletNetwork | null;
  recs_url: string | null;
  receipt_url: string | null;
  source_registry: string | null;
  destination_registry: string | null;
  need_confirm_payment_by_seller: boolean | null;
  need_confirm_delivery: boolean | null;
  seller_company_uuid: string | null;
}

export interface IEecsTransactionModal {
  type: EEecsTransactionModals;
}
